<template>
    <div class="service-calls">
        <h6 class="font-weight-bold my-3">Helpline Engagement: Calls</h6>
        <div class="d-flex flex-row justify-content-center report-summary mb-3">
            <div class="counter p-2 flex-fill text-center">
                <h2>{{ calls.all.total }}</h2>
                <p>Total Calls</p>
            </div>
            <div class="counter p-2 flex-fill text-center">
                <h2>{{ calls.month.total }}</h2>
                <p>This Month</p>
            </div>
            <div class="counter p-2 flex-fill text-center">
                <h2>{{ calls.all.verified }}</h2>
                <p>DPA Passed Total</p>
            </div>
            <div class="counter p-2 flex-fill text-center">
                <h2>{{ calls.month.verified }}</h2>
                <p>DPA Passed Month</p>
            </div>
        </div>
        <div v-if="services.length > 1" v-for="service in services" class="d-flex flex-row justify-content-center report-summary mb-3">
            <div class="counter p-2 flex-fill text-center">
                <h2>{{ calls.month.services[service['site_id']]['total'] }} <span class="text-muted">|</span> {{ calls.all.services[service['site_id']]['total'] }}</h2>
                <p><strong>{{ service.name }}</strong><br>Total Calls<br><small class="text-muted" style="font-size: 0.65em;">Month | Total</small></p>
            </div>
            <div class="counter p-2 flex-fill text-center">
                <h2>{{ calls.month.services[service['site_id']]['verified'] }} <span class="text-muted">|</span> {{ calls.all.services[service['site_id']]['verified'] }}</h2>
                <p><strong>{{ service.name }}</strong><br>DPA Passed<br><small class="text-muted" style="font-size: 0.65em;">Month | Total</small></p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ReportCalls",
        props: ['calls','services']
    }
</script>

<style scoped>

</style>
